module.exports = __webpack_public_path__ + "img/UpdateMaliciousCode.837f7a77.png";